/* tslint:disable */
/* eslint-disable */
/**
 * ald-routing-api
 * Node.js OpenAPI implemented by TSOA
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleDirectionsResponseRoutes
 */
export interface GoogleDirectionsResponseRoutes {
    /**
     * 
     * @type {number}
     * @memberof GoogleDirectionsResponseRoutes
     */
    distance: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleDirectionsResponseRoutes
     */
    duration: number;
}

export function GoogleDirectionsResponseRoutesFromJSON(json: any): GoogleDirectionsResponseRoutes {
    return GoogleDirectionsResponseRoutesFromJSONTyped(json, false);
}

export function GoogleDirectionsResponseRoutesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleDirectionsResponseRoutes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'distance': json['distance'],
        'duration': json['duration'],
    };
}

export function GoogleDirectionsResponseRoutesToJSON(value?: GoogleDirectionsResponseRoutes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'distance': value.distance,
        'duration': value.duration,
    };
}


